import { render, staticRenderFns } from "./PurchMaintenance.vue?vue&type=template&id=81b17a42&scoped=true"
import script from "./PurchMaintenance.vue?vue&type=script&lang=js"
export * from "./PurchMaintenance.vue?vue&type=script&lang=js"
import style0 from "./PurchMaintenance.vue?vue&type=style&index=0&id=81b17a42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b17a42",
  null
  
)

export default component.exports